import { ArrowLeft } from '@nosinovacao/fe-icons';
import { Button, Sheet, Stepper, useI18n, useInMediaQuery } from '@nosinovacao/nosid-mfe-common';
import { useMemo, useState } from 'react';
import { MfaSetupSheetContext } from './context';
import { type MfaSetupSheetProps } from './props';

// ? matches the SheetContent default animationDuration so the slide-out finishes before we navigate
const CLOSE_ANIMATION_MS = 300;
const STEP_COUNT = 4;

export function MfaSetupSheetLight({ back, children, close, step }: Readonly<MfaSetupSheetProps>) {
  const { t } = useI18n();
  const isTablet = useInMediaQuery('tablet');
  const [open, setOpen] = useState(true);
  const [subView, setSubView] = useState<{ onBack: () => void } | null>(null);
  const context = useMemo(() => ({ setSubView }), []);
  // ? a sub-view replaces the whole step, so it owns the back button and hides the stepper
  const onBack = subView?.onBack ?? (step?.canGoBack ? back : null);
  return (
    <Sheet
      skin="light"
      open={open}
      onOpenChange={(next) => {
        if (next) return;
        setOpen(false);
        setTimeout(close, CLOSE_ANIMATION_MS);
      }}
      animationDirection={isTablet ? 'right' : 'bottom'}
      contentAriaLabel={t('Security.AuthenticatorAppCard.Setup.SheetLabel').toString()}
      className="z-[60] flex flex-col gap-6 pb-5 tablet:pb-8"
      overlayClassName="z-[60] max-tablet:bg-transparent"
      data-tid="mfa-setup-sheet"
      back={
        onBack && (
          <Button
            skin="light"
            variant="tertiary"
            type="button"
            onClick={onBack}
            data-tid="button-back"
            className="w-fit no-underline"
          >
            <ArrowLeft /> {t('Common.Back')}
          </Button>
        )
      }
    >
      <MfaSetupSheetContext.Provider value={context}>
        {step && !subView && (
          <Stepper
            skin="light"
            stepCount={STEP_COUNT}
            currentStep={step.number}
            title={step.titleKey && t(step.titleKey).toString()}
            subtitle={step.subtitleKey && t(step.subtitleKey).toString()}
            className="[&>div]:w-fit"
          />
        )}
        {children}
      </MfaSetupSheetContext.Provider>
    </Sheet>
  );
}
